<template>
  <b-modal
      id="show-modal-processed-work-orders"
      no-close-on-esc
      no-close-on-backdrop
      size="lg"
      centered
      hide-footer
      hide-header-close
      v-model="showModal"
  >
    <!-- Header com título -->
    <template #modal-title>
      Ordens de Serviço Processadas
    </template>

    <!-- Tabela -->
    <b-table
        id="tableAgendamento"
        responsive
        :fields="table.fields"
        :items="items"
        bordered
        small
        hover
    >
      <template #cell(unidade)="row">
        <span>{{ row.item.unidade }}</span>
      </template>

      <template #cell(documento)="row">
        <span>
          {{ row.item.documento | formataCpfCnpj }}
        </span>
      </template>

      <template #cell(dataAgendamento)="row">
        <span>{{ formatDate(row.item.dataAgendamento) }}</span>
      </template>

      <template #cell(actions)="row">
        <feather-icon
            role="button"
            class="text-custom-blue"
            icon="DownloadIcon"
            size="18"
            @click.prevent="downloadOS(row.item)"
        />
      </template>
    </b-table>
    <div class="d-flex justify-content-end mt-1">
      <b-button variant="primary-button" @click="confirmAction">
        Finalizar
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import {BButton, BModal, BTable} from "bootstrap-vue";

export default {
  components: {
    BButton,
    BModal,
    BTable,
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    }
  },
  mounted() {
  },
  data() {
    return {
      table: {
        fields: [
          { key: "unidadeOperacional", label: "Unidade" },
          { key: "documento", label: "CNPJ Empresa" },
          { key: "dataAgendamento", label: "Data Agendamento" },
          { key: "actions", label: "Ações" },
        ]
      },
    };
  },
  methods: {
    formatDate(date) {
      if (!date) return "-";
      return new Date(date).toLocaleDateString("pt-BR");
    },
    downloadOS(item) {
      this.$emit("download", item);
    },
    confirmAction(modalEvent) {
      this.$emit("confirmed");
      modalEvent.preventDefault();
    },
  },
};
</script>

<style scoped>
.text-custom-blue {
  color: #007bff;
  cursor: pointer;
}

/* Deixar modal o maior possível */
.modal-fullscreen-custom {
  max-width: 50% !important;
  margin: 0;
}
</style>
